import React, { ReactNode } from "react";

import {
  LayersIcon,
  OctahedronIcon,
  CubeIcon,
  TetrahedronIcon,
} from "app/assets/icons";

const PLANS_BASE_FEATURES: { name: string }[] = [
  {
    name: "Tienda virtual",
  },
  {
    name: "Control de inventario",
  },
  {
    name: "Control de ventas",
  },
  {
    name: "Monitoreo seguidores",
  },
];

export const PLANS: {
  icon: ReactNode;
  name: string | ReactNode;
  price: string;
  features: { name: string; isNew: boolean }[];
}[] = [
  {
    icon: <LayersIcon height="40px" style={{ margin: "8px 0" }} />,
    name: "Plan base",
    price: "5% por venta",
    features: PLANS_BASE_FEATURES.map((feature) => ({
      ...feature,
      isNew: true,
    })),
  },
  {
    icon: <CubeIcon height="40px" style={{ margin: "8px 0" }} />,
    name: "Plan cubo",
    price: "$595K (pago único)",
    features: [
      ...PLANS_BASE_FEATURES.map((feature) => ({ ...feature, isNew: false })),
      {
        name: "Imagen de marca",
        isNew: true,
      },
    ],
  },
  {
    icon: <TetrahedronIcon height="40px" style={{ margin: "8px 0" }} />,
    name: "Plan pirámide",
    price: "$120K (pago único)",
    features: [
      ...PLANS_BASE_FEATURES.map((feature) => ({ ...feature, isNew: false })),
      {
        name: "Fotos de catálogo (20)",
        isNew: true,
      },
    ],
  },
  {
    icon: <OctahedronIcon height="56px" />,
    name: "Plan prisma",
    price: "$55K/mes",
    features: [
      ...PLANS_BASE_FEATURES.map((feature) => ({ ...feature, isNew: false })),
      {
        name: "Plan de comunicación y RRSS",
        isNew: true,
      },
    ],
  },
];
